import { Page } from "_core/components";
import { Button, Heading1, P, Stack, Strong } from "@ovotech/element";
import * as React from "react";
import { ProductUrls } from "_core/types";
import { useNavigate } from "react-router";
import Mixpanel from "_core/analytics/Mixpanel";
import { AnalyticsEvents } from "_core/analytics/AnalyticsEvents";
import { useStore } from "_core/store";

export const KerboChargePage = () => {
  const navigate = useNavigate();
  const { charger } = useStore();

  const handleClick = () => {
    Mixpanel.track(AnalyticsEvents.CLICKEDBUTTON, {
      buttonId: "kerbo-charge-redirection",
      pageName: ProductUrls.KerboCharge,
      charger,
    });
    window.open("https://www.kerbocharge.com/ovo", "_self");
  };

  return (
    <Page url={ProductUrls.KerboCharge}>
      <Heading1 className={"SurfaceHeading"}>
        Install a cross pavement channel for your EV Charger.
      </Heading1>
      <Stack spaceBetween={4}>
        <P size={"lg"}>
          With Kerbo Charge, you can enjoy convenient home charging, even
          without off-street parking. They create a narrow channel and install a
          duct into the pavement which lets people use the pavement as normal.
        </P>
        <P size={"lg"}>
          Once Kerbo Charge installs your channel, we’ll take care of the rest.
          Just choose your EV charger and we’ll install it for you.
        </P>
        <P size={"lg"}>
          <Strong>Check if Kerbo Charge is available in your area.</Strong>
        </P>
      </Stack>

      <div className={"ButtonContainer"}>
        <Button
          variant="outline"
          iconLeft="chevron-left"
          data-testid="kerbo-charge-back-button"
          onClick={() => navigate(ProductUrls.OffStreetParking)}
        >
          Back
        </Button>
        <Button
          iconRight="chevron-right"
          data-testid="kerbo-charge-link-button"
          onClick={handleClick}
        >
          Go to Kerbo Charge
        </Button>
      </div>
    </Page>
  );
};
